module.exports = __webpack_public_path__ + "media/images/pic/workshops/quiz-o-polsce-e35298f9c422aa94cdccffd353e1730c.jpeg";